import script from "./DocumentReview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentReview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentReview.vue?vue&type=style&index=0&id=513299a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513299a9"]])

export default __exports__